export default __webpack_public_path__ + "static/Restaurant3-379c79284d5c1849595077f27e707216.jpg";